import { cn } from "../../utils/tailwindUtils";

/**
 * Segmented filter toggle used across attendance, payroll, and reports screens.
 */
export const SegmentSwitch = ({ options, value, onChange, className, disabled = false }) => (
    <div
        className={cn(
            "inline-flex rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden flex-shrink-0",
            disabled && "opacity-40 pointer-events-none",
            className,
        )}
    >
        {options.map((opt) => {
            const optValue = typeof opt === "string" ? opt : opt.value;
            const label = typeof opt === "string" ? opt : opt.label;
            const isActive = value === optValue;

            return (
                <button
                    key={optValue}
                    type="button"
                    disabled={disabled}
                    onClick={() => onChange(optValue)}
                    className={cn(
                        "px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap",
                        isActive
                            ? "bg-sidebar-primary text-white"
                            : "bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                    )}
                >
                    {label}
                </button>
            );
        })}
    </div>
);
